import { compose, withStateHandlers } from 'recompose';
import { addProps } from 'utils/recompose';
import styles from './styles.module.scss';

export const setIsVisible = ({ isVisible }) => () => ({
  isVisible: !isVisible,
});

const arrowStyles = ({ isVisible }) => {
  return `${styles.arrow} ${isVisible && styles.arrowInverted}`;
};

export default compose(
  withStateHandlers({ isVisible: false }, { setIsVisible }),
  addProps({ arrowStyles }),
);
